"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectExtendedResponseModelFiction = void 0;
exports.ProjectExtendedResponseModelFiction = {
    Fiction: "fiction",
    NonFiction: "non-fiction",
};
